import { render, staticRenderFns } from "./carstatistics.vue?vue&type=template&id=47f72126&scoped=true&"
import script from "./carstatistics.vue?vue&type=script&lang=js&"
export * from "./carstatistics.vue?vue&type=script&lang=js&"
import style0 from "./carstatistics.vue?vue&type=style&index=0&id=47f72126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f72126",
  null
  
)

export default component.exports